module.exports = __webpack_public_path__ + "img/people6.ebe2cbff.png";